import { useEffect, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

export function PublicReminderConfirmPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const customerAppPath = useMemo(() => {
    if (!token) {
      return null;
    }
    return `/customer/reminders/confirm/${encodeURIComponent(token)}`;
  }, [token]);

  useEffect(() => {
    if (!customerAppPath) {
      return undefined;
    }

    const redirectTimer = window.setTimeout(() => {
      navigate(customerAppPath, { replace: true });
    }, 250);

    return () => window.clearTimeout(redirectTimer);
  }, [customerAppPath, navigate]);

  return (
    <main
      className="min-h-screen bg-slate-50 px-4 py-8 flex items-center justify-center"
      data-testid="public-reminder-confirm-page"
    >
      <section className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-6 shadow-sm">
        <div className="mb-6">
          <p className="text-xs uppercase tracking-[0.2em] text-slate-400">FullBook</p>
          <p
            className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-slate-500"
            data-testid="public-reminder-confirm-eyebrow"
          >
            Conferma appuntamento
          </p>
        </div>

        <div
          className="mb-5 flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-slate-50 text-slate-500"
          aria-hidden="true"
        >
          ...
        </div>

        {!customerAppPath ? (
          <>
            <h1
              className="text-2xl font-semibold text-slate-900 section-title"
              data-testid="public-reminder-confirm-title"
            >
              Link non disponibile
            </h1>
            <p
              className="mt-3 text-sm leading-6 text-slate-600"
              data-testid="public-reminder-confirm-message"
            >
              Non siamo riusciti ad aprire questa schermata. Riprova dal messaggio ricevuto.
            </p>
          </>
        ) : (
          <>
            <h1
              className="text-2xl font-semibold text-slate-900 section-title"
              data-testid="public-reminder-confirm-title"
            >
              Ti stiamo portando alla schermata cliente
            </h1>
            <p
              className="mt-3 text-sm leading-6 text-slate-600"
              data-testid="public-reminder-confirm-message"
            >
              Tra poco vedrai i dettagli dell'appuntamento e potrai decidere se confermare.
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to={customerAppPath}
                replace
                className="h-11 flex-1 rounded-sm bg-slate-900 px-4 text-sm font-medium text-white flex items-center justify-center"
                data-testid="public-reminder-confirm-open-customer-app"
              >
                Apri schermata cliente
              </Link>
            </div>
          </>
        )}
      </section>
    </main>
  );
}
